import { Event } from "../../../Global/Base/Events";
import { IValidationError } from "../../Basic/EOWExceptionsInterfaces";
/**
* Rozhrani pro datove objekty majici stav validnosti a umoznujici udrzovat informace o validacnich chybach
*/
export interface IValidationDataObject<T> {
    /**
     * Identifikator datoveho zaznamu
     */
    id: any;
    /**
     * Zda je zaznam ve validnim stavu
     */
    isValid: boolean;
    /**
     * Udalost zmeny stavu validnosti
     */
    //validityChanged: any;
    /**
     * Vraci kopii vsech validacnich chyb
     */
    getValidationErrors: () => T[];
    /**
     * Prida novou chybu do vnitrniho seznamu
     * @param error libovolna chyba
     */
    addError: (error: T) => void;
    /**
     * Odebere chybu
     * @param error libovolna chyba
     */
    removeError: (error: T) => void;
    /**
     * Odstrani vsechny existujici chyby zaznamu
     */
    clearErrors: () => void;
    /**
     * Událost volána pri změně validity objektu
     */
    validityChange: Event<any, boolean>;
}

// eslint-disable-next-line unused-imports/no-unused-vars
export class IValidationDataObject<T> {
    private static _properties: (keyof IValidationDataObject<any>)[] = ["id", "isValid", "validityChange"];
    private static _methods: (keyof IValidationDataObject<any>)[] = ["getValidationErrors", "addError", "removeError", "clearErrors"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance !== null && typeof instance === "object" && !this._properties.some((value) => !Reflect.has(instance, value)) &&
        !this._methods.some(value => typeof instance[value] !== "function");
    }
}

export interface IValidationDataSimple {
    error: IValidationError;
}
